<template>
  <b-modal
    id="product-addons-modal"
    :title="titleTextDisplay"
    footer-class="border-top py-3"
    content-class="p-0"
    body-class="px-5"
    centered
    scrollable
    size="lg"
    @shown="initForm"
    @hide="$parent.is_manage = false"
  >
    <b-form>
      <div
        v-for="(addOnCategory, addOnCategoryIndex) in form"
        :key="`add-on-category-name-${addOnCategoryIndex}`"
      >
        <b-form-group
          label-class="product-creation-labels"
          class="mb-0"
          :state="validateState(addOnCategoryIndex, 'name')"
          :invalid-feedback="formErrors[addOnCategoryIndex].name"
        >
          <template slot="label">
            Add-On Name <span class="font-weight-bold text-danger">*</span>
          </template>
          <b-form-input
            :id="`add-on-category-name-${addOnCategoryIndex}`"
            v-model="addOnCategory.name"
            maxlength="30"
          >
          </b-form-input>
        </b-form-group>
        <b-col md="6" class="pl-0">
          <b-form-group>
            <label for="allow_multiple_selection" class="d-flex align-items-center" @click="toggleAllowMultiple">
              <switches 
                v-model="addOnCategory.allow_multiple_selection" 
                theme="custom" 
                color="primary" 
                type-bold="true"
                :style="{ 'top': '15px' }"></switches>
                <span class="ml-2 mr-3 product-creation-labels mt-2">Allow multiple selection
                </span>
            </label>
            <b-form-group
              v-show="addOnCategory.allow_multiple_selection"
              class="pl-2"
              style="font-size: 13px; margin-left: 51px !important;"
            >
              <template slot="label">
                Set limit <span class="font-weight-bold text-danger">*</span>
              </template>
              <b-form-group
                  :state="validateState(addOnCategoryIndex, 'limit')"
                  :invalid-feedback="formErrors[addOnCategoryIndex].limit">
                <b-form-input
                  type="number"
                  v-model="addOnCategory.limit"
                >
                </b-form-input>
              </b-form-group>
            </b-form-group>
          </b-form-group>
        </b-col>
        <div
          class="bg-light rounded border mb-3 p-3"
          v-for="(option, optionIndex) in addOnCategory.items"
          :key="`add_on_option_${optionIndex}`"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                label-class="product-creation-labels d-flex align-items-center justify-content-between"
                :state="validateState(addOnCategoryIndex, 'items', optionIndex)"
                :invalid-feedback="
                  formErrors[addOnCategoryIndex].items[optionIndex].name
                "
              >
                <template slot="label">
                  <div>
                    Add-On Option
                    <span class="font-weight-bold text-danger">*</span>
                  </div>
                  <img
                    :id="`delete-add-on-option-${addOnCategoryIndex}-${optionIndex}`"
                    src="@/assets/images/actions/delete.svg"
                    :alt="`Delete Variant Option ${optionIndex}`"
                    @click="deleteOption(addOnCategoryIndex, optionIndex)"
                    v-if="addOnCategory.items.length > 1"
                  />
                </template>
                <b-form-input
                  :id="`add-on-option-${optionIndex}`"
                  v-model="option.name"
                  maxlength="30"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                label="Visibility"
                label-class="product-creation-labels"
              >
                <switches
                  v-model="option.visibility"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: 12px"
                  :emit-on-mount="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group
                label="Is Free"
                label-class="product-creation-labels"
              >
                <switches
                  v-model="option.is_free"
                  theme="custom"
                  color="primary"
                  type-bold="true"
                  style="top: 12px"
                  :emit-on-mount="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-row>
                <b-col md="6" v-if="!option.is_free">
                  <b-form-group
                    label-class="product-creation-labels"
                    :state="
                      validateState(addOnCategoryIndex, 'items', optionIndex)
                    "
                    :invalid-feedback="
                      formErrors[addOnCategoryIndex].items[optionIndex].price
                    "
                  >
                    <template slot="label">
                      Price <span class="font-weight-bold text-danger">*</span>
                    </template>
                    <b-input-group
                      :id="`addon-price-input-group-${addOnCategoryIndex}-${optionIndex}`"
                    >
                      <template slot="prepend">
                        <b-input-group-text class="py-1">₱</b-input-group-text>
                      </template>
                      <b-form-input
                        :id="`${addOnCategoryIndex}-add-on-option-price-${optionIndex}`"
                        type="number"
                        v-model="option.price"
                      >
                      </b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label-class="product-creation-labels"
                    :state="
                      validateState(addOnCategoryIndex, 'items', optionIndex)
                    "
                    :invalid-feedback="
                      formErrors[addOnCategoryIndex].items[optionIndex].sku
                    "
                  >
                    <template slot="label">
                      SKU <span class="font-weight-bold text-danger">*</span>
                    </template>
                    <b-form-input
                      :id="`${addOnCategoryIndex}-add-on-option-sku-${optionIndex}`"
                      v-model="option.sku"
                      @keyup.native="trimSpaces($event)"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <b-form-group>
          <b-button
            variant="ghost"
            class="text-primary border font-weight-bold create-button px-3"
            @click="addOption(addOnCategoryIndex)"
          >
            + Add Option
          </b-button>
        </b-form-group>
      </div>
    </b-form>
    <template slot="modal-footer">
      <b-button variant="ghost" class="btn-cancel" @click="close"
        >Cancel</b-button
      >
      <b-button variant="primary" @click="addAddOn">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { required, requiredIf, maxValue } from "vuelidate/lib/validators";
import Switches from "vue-switches";
import { productsMixins } from "@/mixins/products_mixins";

function initializeForm() {
  return [
    {
      name: null,
      allow_multiple_selection: false,
      limit: null,
      items: [
        {
          name: null,
          price: null,
          sku: null,
          is_free: false,
          visibility: true,
        },
      ],
    },
  ];
}

export default {
  props: {
    is_manage: Boolean,
    add_on_category_index: Number,
  },
  components: { Switches },
  data() {
    return {
      form: initializeForm(),
    };
  },
  computed: {
    ...mapState("products", ["add_ons"]),
    titleTextDisplay() {
      if (this.is_manage) return "Manage Add-Ons";
      else return "Create Add-On";
    },
    formErrors() {
      let errors = this.form.map((addOn) => {
        return {
          name: null,
          limit: null,
          items: addOn.items.map(() => ({
            name: null,
            price: null,
            sku: null,
          })),
        };
      });

      const validations = {
        name: ["required"],
        items: ["required"],
      };
      if (this.form.allow_multiple_selection) validations.push({limit: ['required']});

      const validation_messages = {
        required: "This field is required.",
        maxValue: "maxValue error"
      };

      const isDirtyAndInvalid = (addOnIndex, field, optionIndex = null) => {
        if (optionIndex === null) {
          return (
            this.$v.form.$each[addOnIndex][field].$dirty &&
            !this.$v.form.$each[addOnIndex][field].required
          );
        } else {
          return (
            this.$v.form.$each[addOnIndex].items.$each[optionIndex][field]
              .$dirty &&
            !this.$v.form.$each[addOnIndex].items.$each[optionIndex][field]
              .required
          );
        }
      };

      Object.keys(validations).forEach(() => {
        this.form.forEach((addOn, addOnIndex) => {
          Object.keys(addOn).forEach((field) => {
            if (field === "name" && isDirtyAndInvalid(addOnIndex, field))
              errors[addOnIndex][field] = validation_messages.required;
            if (field === "items") {
              const required_fields = ["name", "price", "sku"];
              addOn[field].forEach((option, optionIndex) => {
                required_fields.forEach((key) => {
                  if (isDirtyAndInvalid(addOnIndex, key, optionIndex))
                    errors[addOnIndex].items[optionIndex][key] =
                      validation_messages.required;
                });
              });
            }
            if (field === "limit") {
              if (isDirtyAndInvalid(addOnIndex, field)) 
                errors[addOnIndex][field] = validation_messages.required;
              // else if (this.$v.form.$each[addOnIndex][field].$dirty && !this.$v.form.$each[addOnIndex][field].maxValue) 
              //   errors[addOnIndex][field] = validation_messages.maxValue;
              
            }
          });
        });
      });

      return errors;
    }
  },
  validations () {
    let _this = this;
    return {
      form: {
        $each: {
          name: {
            required,
          },
          limit: {
            required: requiredIf((item) => item.allow_multiple_selection),
            // maxValue: maxValue(_this.form[0].items.length)
          },
          items: {
            $each: {
              name: {
                required,
              },
              price: {
                required: requiredIf((item) => !item.is_free),
              },
              sku: {
                required,
              },
            },
          },
        },
      },
    };
  },
  mixins: [productsMixins],
  methods: {
    initForm() {
      if (this.is_manage)
        this.form = [
          {
            name: this.add_ons[this.add_on_category_index].name,
            allow_multiple_selection: (this.add_ons[this.add_on_category_index].limit > 1),
            limit: this.add_ons[this.add_on_category_index].limit,
            uuid: this.add_ons[this.add_on_category_index].uuid,
            items: this.add_ons[this.add_on_category_index].items.map(
              (item) => ({
                uuid: item.uuid,
                name: item.name,
                price: item.price,
                sku: item.sku,
                is_free: item.is_free,
                visibility: item.visibility,
              })
            ),
          },
        ];
      else this.form = initializeForm();

      this.$v.$reset();
    },
    close() {
      this.$parent.is_manage = false;

      this.$root.$emit("bv::hide::modal", "product-addons-modal");
    },
    addOption(variantIndex) {
      this.form[variantIndex].items.push({
        name: null,
        price: null,
        sku: null,
        visibility: true,
        is_free: false,
      });
    },
    deleteOption(variantIndex, optionIndex) {
      this.form[variantIndex].items.splice(optionIndex, 1);
    },
    addAddOn() {
      this.$v.form.$touch();

      if (!this.$v.form.$invalid) {
        this.$nextTick(() => {
          if (this.is_manage) this.manageAddOns();
          else this.addAddOns();
        });
      }
    },
    addAddOns() {
      const addOn = {
        name: this.form[0].name,
        limit: this.form[0].allow_multiple_selection ? parseInt(this.form[0].limit) : 1,
        uuid: null,
        items: this.form[0].items.map((option) => ({
          uuid: null,
          name: option.name,
          currency: "PHP",
          price: option.price,
          sku: option.sku,
          visibility: option.visibility,
          is_free: option.is_free,
        })),
      };

      this.$store.commit("products/pushAddOns", addOn);
      this.close();
    },
    manageAddOns() {
      const add_ons = this.form.map((addOn) => {
        return {
          name: addOn.name,
          allow_multiple_selection: (addOn.limit > 1),
          limit: addOn.allow_multiple_selection ? addOn.limit : 1,
          uuid: addOn.uuid,
          items: addOn.items.map((option) => ({
            uuid: option.uuid,
            name: option.name,
            currency: "PHP",
            price: option.price,
            sku: option.sku,
            visibility: option.visibility,
            is_free: option.is_free,
          })),
        };
      });

      this.$store.commit("products/setAddOns", {
        data: add_ons[0],
        data_index: this.add_on_category_index,
      });
      this.$root.$emit("productAddOnsUpdate");
      this.close();
    },
    validateState(variationIndex, field, optionIndex = null) {
      if (optionIndex) {
        if (this.formErrors[variationIndex][field][optionIndex]["name"])
          return false;

        const { $dirty, $error } =
          this.$v.form.$each[variationIndex][field].$each[optionIndex].name;

        return $dirty ? !$error : null;
      } else {
        if (this.formErrors[variationIndex][field]) return false;

        const { $dirty, $error } = this.$v.form.$each[variationIndex][field];

        return $dirty ? !$error : null;
      }
    },
    toggleAllowMultiple () {
      if (!this.form[0].allow_multiple_selection) {
        this.form[0].limit = "";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.btn.create-button {
  border-radius: 20px;
  font-size: 15px;
}
[id^="delete-add-on-option-"] {
  cursor: pointer;
}
[id^="addon-price-input-group-"] {
  .input-group-text {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .form-control {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
